import { createStore, applyMiddleware } from 'redux';

import { persistStore, persistReducer } from 'redux-persist';
import { routerMiddleware } from 'react-router-redux';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';
import rootReducer from './rootReducer';
import history from './history';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';

const middlewares = [thunk, routerMiddleware(history)];

const persistConfig = {
  key: 'root',
  whitelist: ['clinician', 'patient', 'questionnaire', 'recommendations'],
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const composeEnhancers = composeWithDevTools({});

export const store = createStore(persistedReducer, {}, composeEnhancers(applyMiddleware(...middlewares)));
export const persistor = persistStore(store);



// WEBPACK FOOTER //
// ./src/store.js